import Vue from "vue";
import Router from "vue-router";

import menuRouter from "./menuRoutes";

Vue.use(Router);

const router = new Router({
  routes: [
    menuRouter,
    {
      path: "/",
      name: "home",
      redirect: "/home",
    },
    {
      path: "/notFound",
      name: "404",
      component: () => import("../views/error/404"),
    },
    { path: "*", redirect: "/notFound", hidden: true },
  ],
});
export default router;
